<template>
  <el-menu class="navbar" mode="horizontal">

    <el-col class="header_logo" :span="6">
      <img src="../../assets/rimagLogo.png" alt="">
    </el-col>
    <el-dropdown class="hospital-container" @command="handleCommand" trigger="click">
      <div class="hospital-wrapper">
        <svg-icon icon-class='hospital' style="font-size:24px;margin-right:10px"></svg-icon>
        {{currentUserRoleDepart.hospName}} - {{currentUserRoleDepart.departName}}
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="hospital-dropdown" slot="dropdown">
          <el-dropdown-item :command="hospital.departId" v-for="hospital in hospitals" :key="hospital.hospital">
            {{hospital.hospName}}-{{hospital.departName}}
          </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-popover placement="bottom" v-model='userMenu' trigger="click">
      <div class="user-menu">
        <ul class='menu-father-list'>
          <li>
            <ul class='menu-child-list' @click='returnDashboard'>
              <li><svg-icon  icon-class='home'></svg-icon></li>
              <li>回到主页</li>
            </ul>
          </li>
          <li>
            <ul class='menu-child-list' @click='userSet'>
              <li><svg-icon  icon-class='userinfo'></svg-icon></li>
              <li>个人资料</li>
            </ul>
          </li>
           <li v-if="roles.indexOf('平台')!== -1">
            <ul class='menu-child-list' @click='statistics' >
              <li><svg-icon  icon-class='statistics'></svg-icon></li>
              <li>平台数据</li>
            </ul>
          </li>
          <!-- <li>
            <ul class='menu-child-list'>
              <li><svg-icon icon-class='userlist'></svg-icon></li>
              <li>选择表头</li>
            </ul>
          </li>
          <li>
            <ul class='menu-child-list' >
              <li><svg-icon icon-class='help'></svg-icon></li>
              <li>帮助文档</li>
            </ul>
          </li> -->
        </ul>
      </div>
      <div>
        <el-button  @click="logout"  type="text" style="width:100%;text-align:center;color:#595959;height: 40px;padding-bottom:0px;">
          退出平台
        </el-button>
      </div>
      <el-button slot="reference" type="text" style="color:#fff;float:right;height: 60px;padding:0px;margin-right:20px;">
        <div class="avatar-wrapper">
          <img v-if="avatars" :src="avatars" class="avatar">
          <img v-else src="../../assets/user-head.jpg" class="avatar">
          <div style="display:inline-block;height:40px;float: left;margin-left:5px;">
            <span style="display: block;margin:5px;font-size:14px;" class="user-info">{{name}}</span>
            <span style="display: block;margin:5px;margin-top:7px;font-size:12px;text-align: left;" class="user-info">{{currentUserRoleDepart.roleName}}</span>
          </div>
          <svg-icon style="margin: 14px 5px;" :class="{'is-active':userMenu}" class="menu" icon-class='menu'></svg-icon>
        </div>
      </el-button>
    </el-popover>
    <!-- <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <svg-icon icon-class="user" class="user-avatar"></svg-icon>
        <span class="user-info">{{name+'('+currentUserRoleDepart.roleName+')'}}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            主页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">登出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      defaultHospitalName: '',
      username: '',
      userroles: '',
      userMenu: false,
      avatars: ''
    }
  },
  components: {
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'roles',
      'hospitals',
      'currentUserRoleDepart'
    ])
  },
  created: function() {
    if (this.avatar) {
      this.avatars = 'data:image/jpeg;base64,' + this.avatar
      // console.log(this.avatar)
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        // 清除自动登录信息
        var loginAutoFromLocalStorage = localStorage.getItem('loginAuto')
        if (loginAutoFromLocalStorage) {
          localStorage.removeItem('loginAuto')
          localStorage.removeItem('userinfo')
        }
        location.reload()
      }).catch(() => {
        location.reload()
      })
    },
    returnDashboard() {
      this.$router.push({ path: '/dashboard' })
      this.userMenu = false
      // location.reload()
    },
    userSet() {
      this.$router.push({ path: '/User' })
      this.userMenu = false
    },
    statistics() {
      this.$router.push({ path: '/Statistics' })
      this.userMenu = false
    },
    handleCommand(command) {
      if (this.currentUserRoleDepart.departId !== command) {
        this.$store.dispatch('PostSwitchDepart', command).then(() => {
          location.reload()
        })
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 60px;
  line-height: 60px;
  border-radius: 0px !important;
  background-color: #397ee3;
  position:fixed;
  width: 100%;
  z-index: 1001;
  top:0;
  text-align: center;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .menu {
    transform: rotate(0deg);
    transition: .38s;
    transform-origin: 50% 50%;
  }
  .menu.is-active {
    transform: rotate(90deg);
  }
  .avatar{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    float: left;
  }
  .avatar-container {
    height: 60px;
    line-height: 60px;
    display: inline-block;
    float: right;
    margin-right: 35px;
    color: #fff;
    .avatar-wrapper {
      cursor: pointer;
      height: 100%;
      position: relative;
      .user-avatar {
        width: 16px;
        height: 20px;
        border-radius: 10px;
        margin-top: 20px;
        color: #fff;
        float: left;
      }
      .user-info{
        margin: 0px !important;
        display: inline-block;
        float: left;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
        color:#fff;
      }
    }
  }
  .header_logo {
      display: inline-block;
      width: 130px;
      height: 55px;
      float: left;
      margin-left: 1.5%;
      margin-top: 4px;
      line-height: 60px;
    }
    .header_logo img {
      display: inline-block;
      width: 130px;
      margin-left: 2.5px;
    }
    .hospital-container{
      position: static !important;
      display: inline-block;
      color: #fff;
      text-align: center;
      height: 36px;
      line-height: 36px;
      margin: 12px;
      padding: 0px 10px;
      background: #64A3FF;
      border-radius: 5px;
      border: 1px solid #89B9FE;
      .hospital-wrapper {
      cursor: pointer;
      position: relative;
    }}
}
.el-popover{
  .user-menu{
    padding: 10px;
    width: 180px;
    border-bottom: 1px solid #DBDBDB;
  }
  .menu-father-list {
    list-style: none;
    line-height: 80px;
    margin: 0px;
    padding: 0px;
    display: inline-block;
    li {
      float: left;
      width: 80px;
    }
  }
  .menu-child-list {
    cursor: pointer;
    list-style: none;
    height: 80px;
    padding: 0;
    :first-child {
      height: 40px;
      width: 100%;
      text-align: center;
    }
    :last-child {
      height: 40px;
      width: 100%;
      line-height: 40px;
      text-align: center;
    }
    .svg-icon {
      width: 30px;
      color: #3e89e5;
    }
  }
}
</style>

